<div class="g-popup popup" (cmsEscapeKey)="closePopup()">
    <header class="g-popup-header">
        <i (click)="closePopup()" class="g-popup-header-close g-icon g-icon-close-a"></i>
        <div class="g-popup-title">{{'containers_new_container' | translate}}</div>
    </header>
    <div class="g-popup-body">
        <form class="popup-form" novalidate [formGroup]="newContainer" (ngSubmit)="onSubmit(newContainer)">
            <div class="form-body">
                <div class="form-control">
                    <div class="g-input g-input-io"
                         [ngClass]="{filled: newContainer.get('name').value,
                                     invalid: (newContainer.get('name').hasError('required') || newContainer.get('name').hasError('maxlength') || newContainer.get('name').hasError('pattern')) && !newContainer.get('name').pristine}">
                        <input type="text" class="g-input-input" [placeholder]="'common_name' | translate" formControlName="name">
                        <label class="g-input-label">{{'common_name' | translate}}</label>
                        <label class="g-input-validation">
                            <span *ngIf="newContainer.get('name').hasError('required')">
                                {{ 'common_validation_field_required' | translate }}
                            </span>
                            <span *ngIf="newContainer.get('name').hasError('maxlength') && !newContainer.get('name').hasError('pattern')">
                                {{'common_validation_maximum_field_length' | translate: nameValidationInterpolationParams}}
                            </span>
                            <span *ngIf="newContainer.get('name').hasError('pattern')">
                                {{'common_validation_valid_characters' | translate: nameValidationInterpolationParams}}
                            </span>
                        </label>
                    </div>
                </div>
                <div class="form-control">
                    <div class="g-input g-input-io"
                         [ngClass]="{filled: newContainer.get('title').value,
                                     invalid: (newContainer.get('title').hasError('required') || newContainer.get('title').hasError('maxlength')) && !newContainer.get('title').pristine}">
                        <input type="text" class="g-input-input" [placeholder]="'common_title' | translate" formControlName="title">
                        <label class="g-input-label">{{'common_title' | translate}}</label>
                        <label class="g-input-validation">
                            <span *ngIf="newContainer.get('title').hasError('required')">
                                {{ 'common_validation_field_required' | translate }}
                            </span>
                            <span *ngIf="newContainer.get('title').hasError('maxlength')">
                                {{'common_validation_maximum_field_length' | translate: titleValidationInterpolationParams}}
                            </span>
                        </label>
                    </div>
                </div>
               <div class="form-control">
                    <cms-select formControlName="company"
                                [options]="companies"
                                [placeholder]="'common_company' | translate"
                                [title]="'common_company' | translate"
                    ></cms-select>
                </div>
                <div class="form-control">
                    <div class="g-toggle g-toggle-io">
                        <input class="g-toggle-input" type="checkbox" formControlName="createOptimizedImages">
                        <label class="g-toggle-label">{{'resources_create_optimized_images' | translate}}</label>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <div class="form-footer-buttons">
                    <button type="submit"
                        class="form-footer-button g-button g-button-earth"
                        [disabled]="newContainer.invalid">
                        <span class="g-button-title">{{'common_save' | translate}}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
